import styled, { css } from 'styled-components';
import {} from './index.js';
import { getMargins, SYS_SPACE_FIXED_200, SYS_BORDER_RADIUS_MD, SYS_BLUR_BACKGROUND_200, SYS_OPACITY_20_PCT } from '@oneaudi/unified-web-alpha-common';
export const StyledTile = styled.div `
  ${(props) => props.selected
    ? css `
          --gradient-start: ${props.theme.sys.color.surface.interactive.tile
        .selected[100].fill.stops[0]};
          --gradient-end: ${props.theme.sys.color.surface.interactive.tile
        .selected[100].fill.stops[100]};
        `
    : css `
          --gradient-start: ${props.theme.sys.color.surface.interactive.tile
        .default[100].fill.stops[0]};
          --gradient-end: ${props.theme.sys.color.surface.interactive.tile
        .default[100].fill.stops[100]};
        `}
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: --gradient-start, --gradient-end, box-shadow;
  margin: ${(props) => getMargins(props.margin)};
  padding: ${SYS_SPACE_FIXED_200};
  overflow: hidden;
  border-radius: ${SYS_BORDER_RADIUS_MD};
  border: none;
  cursor: pointer;
  box-shadow: inset 0 0 0 1px
    ${(props) => props.selected
    ? props.theme.sys.color.surface.interactive.tile.selected[100].stroke
    : props.theme.sys.color.surface.interactive.tile.default[100].stroke};
  backdrop-filter: blur(${SYS_BLUR_BACKGROUND_200});
  background: linear-gradient(
    180deg,
    var(--gradient-start) 0%,
    var(--gradient-end) 100%
  );

  ${(props) => props.selected
    ? css `
          &:hover:not(:disabled),
          &:active:not(:disabled) {
            --gradient-start: ${(props) => props.theme.sys.color.surface.interactive.tile.selected[200].fill
        .stops[0]};
            --gradient-end: ${(props) => props.theme.sys.color.surface.interactive.tile.selected[200].fill
        .stops[100]};
            box-shadow: inset 0 0 0 1px
              ${(props) => props.theme.sys.color.surface.interactive.tile.selected[200]
        .stroke};
          }
        `
    : css `
          &:hover:not(:disabled),
          &:active:not(:disabled) {
            --gradient-start: ${(props) => props.theme.sys.color.surface.interactive.tile.default[200].fill
        .stops[0]};
            --gradient-end: ${(props) => props.theme.sys.color.surface.interactive.tile.default[200].fill
        .stops[100]};
            box-shadow: inset 0 0 0 1px
              ${(props) => props.theme.sys.color.surface.interactive.tile.default[200]
        .stroke};
          }
        `}

  ${(props) => props.as === 'button' &&
    css `
      text-align: left;
      &:disabled {
        cursor: not-allowed;
        background: ${props.selected
        ? props.theme.sys.color.surface.interactive.tile.selected.disabled
            .fill
        : props.theme.sys.color.surface.interactive.tile.default.disabled
            .fill};
        box-shadow: inset 0 0 0 1px
          ${props.selected
        ? props.theme.sys.color.surface.interactive.tile.selected.disabled
            .stroke
        : props.theme.sys.color.surface.interactive.tile.default.disabled
            .stroke};
      }
    `}


  ${(props) => props.as === 'a' &&
    css `
      display: flex;
      text-decoration: none;
    `}
`;
export const StyledDisabledWrap = styled.div `
  opacity: ${SYS_OPACITY_20_PCT};
`;
//# sourceMappingURL=index.styles.js.map